export let baseUrl;
// export const serverUrl = "production";  ///for live
export const serverUrl = "dev"; // for staging
//
if (serverUrl === "production") {
  baseUrl = "https://app-ecd94517-c094-47ad-ab5b-edc6ed386553.cleverapps.io/api/";
} else {
  baseUrl = "https://app-ecd94517-c094-47ad-ab5b-edc6ed386553.cleverapps.io/api/";
}